import { render, staticRenderFns } from "./FeedProductTransceiversTab.vue?vue&type=template&id=dbdf96da&"
import script from "./FeedProductTransceiversTab.vue?vue&type=script&lang=ts&"
export * from "./FeedProductTransceiversTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports